import { submitCertificateCourseForm } from 'services/certificate';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export const useDownloadCertificate = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.courseLayout.overview',
    });

    const downloadCertificate = async (coursePath: string) => {
        const response = await submitCertificateCourseForm(coursePath);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'certyfikat.pdf');
        link.click();
        toast.success(t('downloadCertificateSuccess'));
    };

    return { downloadCertificate };
};
